import DataTable from "react-data-table-component";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import RoleAssignmentModal from "../../../components/RoleAssignmentModal.js";
import GroupModal from "../../../components/GroupModal.js";
import AddGroupModal from "../../../components/AddGroupModal.js";
import MandalAdminLayout from "../../../components/MandalAdminLayout/MandalAdminLayout.js";

function HaribhaktTable() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [haribhakts, setHaribhakts] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [samparkEmployees, setSamparkEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("all");
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location?.state || {};
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [showAddGroupModal, setShowAddGroupModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [roleOptions, setRoleOptions] = useState([
    { value: "Admin", label: "Admin" },
    { value: "MandalAdmin", label: "MandalAdmin" },
    { value: "MandalSubAdmin", label: "MandalSubAdmin" },
    { value: "SamparkAdmin", label: "SamparkAdmin" },
    { value: "AttendanceWorker", label: "AttendanceWorker" },
    // { value: "Haribhakt", label: "Haribhakt" },
  ]);

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "MandalAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords();
  }, [id]);

  useEffect(() => {
    handleSearch();
  }, [search, haribhakts]);

  const fetchRecords = async () => {
    const token = localStorage.getItem("token");

    if (!id) {
      toast.error("Invalid ID");
      return;
    }

    try {
      const response = await axios.get(
        `${apiURL}/User/GetUserByMandalDetailsId?mandalDetailsId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response?.data?.data || [];
      setHaribhakts(data);
      setFilteredData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  const handleSearch = () => {
    if (!search) {
      setFilteredData(haribhakts);
      return;
    }

    const lowercasedSearch = search.toLowerCase();

    const filtered = haribhakts.filter((row) => {
      const fullName =
        `${row.firstName} ${row.lastName} ${row.surName}`.toLowerCase();
      const address = `${row.houseNo}, ${row.street}, ${
        row.address || ""
      }`.toLowerCase();
      const contactNumbers = [row.contactNo, row.contactNo1, row.contactNo2]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return (
        fullName.includes(lowercasedSearch) ||
        address.includes(lowercasedSearch) ||
        contactNumbers.includes(lowercasedSearch)
      );
    });

    setFilteredData(filtered);
  };

  const handleDelete = async (rowId) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this record?"
    );
    if (!confirmed) return;

    try {
      const response = await axios.delete(`${apiURL}/User/Delete?id=${rowId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      toast.success(response?.data?.message);
      fetchRecords();
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };

  const roleMapping = {
    1: "Admin",
    2: "MandalAdmin",
    3: "MandalSubAdmin",
    4: "SamparkAdmin",
    5: "AttendanceWorker",
    // 6: "Haribhakt",
  };

  const handleRoleChange = (hariBhaktId, newRoles) => {
    const rolesArray = Array.isArray(newRoles) ? newRoles : [newRoles];

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiURL}/User/AssignRole?hariBhaktId=${hariBhaktId}&mandalDetailsId=${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(rolesArray),
    };

    axios
      .request(config)
      .then((response) => {
        console.log("API Response:", response.data);
        if (response.data?.status) {
          setHaribhakts((prevData) =>
            prevData.map((item) =>
              item.id === hariBhaktId ? { ...item, roles: rolesArray } : item
            )
          );
          toast.success(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.message);
      })
      .finally(() => {
        fetchRecords();
      });
  };

  const openModal = (row) => {
    setSelectedRow(row); // Set the selected row data
    setShowModal(true); // Open the modal
  };

  const closeModal = () => {
    setShowModal(false); // Close the modal
    setSelectedRow(null); // Clear the selected row data
  };

  const openGroupModal = (row) => {
    if (!row) {
      console.error("Invalid row data:", row);
      return;
    }
    setSelectedRow(row);
    setShowGroupModal(true);
  };

  const closeGroupModal = () => {
    setShowGroupModal(false);
    setSelectedRow(null);
  };

  const openAddGroupModal = () => {
    setShowAddGroupModal(true);
  };

  const closeAddGroupModal = () => {
    setShowAddGroupModal(false);
    setSelectedRow(null);
  };

  const handleGroupAdded = (newGroupId) => {
    console.log("New group added with ID:", newGroupId);
  };

  const handleGroupChange = (groupId) => {
    // You can implement any state change or side effects after the group is added
    console.log(
      `Group with ID ${groupId} added to user ${selectedRow.firstName} ${selectedRow.lastName}`
    );
  };

  useEffect(() => {
    fetchSamparkEmployees();
    fetchHaribhakts();
  }, [selectedEmployee, id]);

  const fetchSamparkEmployees = async () => {
    const token = localStorage.getItem("token");
  
    try {
      const response = await axios.get(`${apiURL}/SamparkEmploye/Get`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      const employees = response.data.data.filter((item) => item.mandalDetailsId === id);
  
      // Ensure uniqueness using a Set (based on employee ID)
      setSamparkEmployees((prev) => {
        const uniqueEmployees = [...prev, ...employees].reduce((acc, emp) => {
          acc.set(emp.id, emp);
          return acc;
        }, new Map());
        return Array.from(uniqueEmployees.values());
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Error fetching employees");
    }
  };

  const fetchHaribhakts = async () => {
    if (!id) {
      toast.error("Invalid ID");
      return;
    }

    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      let url =
        selectedEmployee === "all"
          ? `${apiURL}/User/GetUserByMandalDetailsId?mandalDetailsId=${id}`
          : `${apiURL}/GroupDetails/GetbySamparkEmployeId?samparkEmployeId=${selectedEmployee}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data || response?.data || [];
      setHaribhakts(data);
      setFilteredData(data);
    } catch (error) {
      toast.error("No haribhakt found");
      setHaribhakts([]);
      setFilteredData([]);
    }
    setLoading(false);
  };

  const handleEmployeeSelect = async (event) => {
    const employeeId = event.target.value;
    setSelectedEmployee(employeeId);

    if (!employeeId) return;

    setLoading(true);
    try {
      const response = await axios.get(
        `${apiURL}/GroupDetails/GetbySamparkEmployeId?samparkEmployeId=${employeeId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setHaribhakts(response.data);
      setFilteredData(response.data);
    } catch (error) {
      toast.error("Error fetching details");
    }
    setLoading(false);
  };

  const [attendanceData, setAttendanceData] = useState({});

  useEffect(() => {
    const fetchAttendanceForAll = async () => {
      let attendanceSummary = {};

      for (let haribhakt of haribhakts) {
        let config = {
          method: "get",
          url: `${apiURL}/UserAttendence/GetByList?haribhaktId=${haribhakt.id}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };

        try {
          const response = await axios.request(config);
          if (response.data.status) {
            const records = response.data.data;
            let uniqueDates = {};
            let present = 0;

            records.forEach((record) => {
              if (!uniqueDates[record.date]) {
                uniqueDates[record.date] = record.attendenceStatus;
              }
            });

            let totalRecords = Object.keys(uniqueDates).length;
            Object.values(uniqueDates).forEach((status) => {
              if (status) present++;
            });

            attendanceSummary[haribhakt.id] = { totalRecords, present };
          }
        } catch (error) {
          console.error(
            `Error fetching attendance for Haribhakt ${haribhakt.id}:`,
            error
          );
        }
      }

      setAttendanceData(attendanceSummary);
    };

    fetchAttendanceForAll();
  }, [haribhakts]);

  const columns = [
    {
      name: "No",
      selector: (row, index) =>
        `${(currentPage - 1) * rowsPerPage + index + 1}`,
      sortable: true,
      width: "65px",
      center: "true",
    },
    {
      name: "Photo",
      selector: (row) => row.imagePath,
      cell: (row) => (
        <img
          src={row.imageBase64 ? row.imageBase64 : "dist/img/user.png"}
          alt="img"
          style={{ width: "75px", height: "auto" }}
        />
      ),
      width: "100px",
      center: "true",
    },
    {
      name: "Name(Total Sabha/Total Aattendance)",
      selector: (row) => {
        const attendance = attendanceData[row.id] || {
          totalRecords: 0,
          present: 0,
        };

        return (
          <div>
            {row.firstName} {row.lastName} {row.surName} &nbsp;
            <span style={{ color: "green", fontWeight: "bold" }}>
              ({attendance.present}
            </span>
            <span
              style={{
                color: "blue",
                fontWeight: "bold",
              }}
            >
              /{attendance.totalRecords})
            </span>
          </div>
        );
      },
      sortable: true,
      width: "400px",
    },

    {
      name: "Mobile Number",
      selector: (row) => {
        const contactNumbers = [row.contactNo, row.contactNo1, row.contactNo2];
        const contactInfo =
          contactNumbers.filter(Boolean).join("<br />") ||
          "No contact available";
        return <div dangerouslySetInnerHTML={{ __html: contactInfo }} />;
      },
      width: "150px",
    },

    {
      name: "Address",
      selector: (row) =>
        row.houseNo + ", " + row.street + ", " + (row.address || ""),
    },

    // selector: (row) => roleMapping[row.role] || "Unknown",
    {
      name: "Actions",
      width: "200px",
      cell: (row) => (
        <div>
          <button
            type="button"
            className="btn btn-warning btn-sm mr-1"
            onClick={() => openModal(row)}
          >
            <i className="fas fa-user-tag"></i>
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-sm mr-1"
            onClick={() => openGroupModal(row)}
          >
            <i className="fas fa-users"></i>
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm mr-1"
            onClick={() =>
              navigate("/update-haribhakt2", {
                state: { id: id, haribhaktId: row.id },
              })
            }
          >
            <i className="fas fa-pen"></i>
          </button>
          <button
            type="button"
            className="btn btn-danger btn-sm mr-1"
            onClick={() => handleDelete(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      ),
      center: "true",
    },
  ];

  return (
    <MandalAdminLayout ac8="active" id={id}>
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h5>Haribhakt Details</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/mandal-admin-dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/manage-mandal2" state={{ id: id }}>
                    Mandal List
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/mandal-info2" state={{ id: id }}>
                    Mandal Information
                  </Link>
                </li>
                <li className="breadcrumb-item">Haribhakt List</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex flex-column flex-md-row justify-content-between">
                    <div className="bd-highlight mb-2 mb-md-0">
                      <input
                        className="form-control"
                        type="search"
                        placeholder="Search"
                        title="Search within table"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    <div className="d-flex align-items-center mb-2 mb-md-0">
                      <div className="d-flex align-items-center">
                        <label className="mr-2">
                          Sampark:
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => setSelectedEmployee(e.target.value)}
                          value={selectedEmployee}
                        >
                          <option value="all">All</option>
                          {samparkEmployees.map((emp) => (
                            <option
                              key={emp.id}
                              value={emp.id}
                            >
                              {emp.firstName} {emp.lastName} {emp.surName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <Link state={{ id: id }} className="ml-2">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => openAddGroupModal()}
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                      </Link>
                    </div>
                    <div className="bd-highlight"></div>
                    <div className="bd-highlight">
                      <Link to="/add-haribhakt2" state={{ id: id }}>
                        <button
                          type="button"
                          className="btn btn-block btn-primary"
                        >
                          <i className="fas fa-plus"></i> Add
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="card-body text-center">
                  {loading ? (
                    <>
                      {" "}
                      <span
                        className="spinner-border spinner-border-sm "
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </>
                  ) : (
                    <DataTable
                      columns={columns}
                      data={filteredData}
                      pagination
                      responsive
                      className="custom-table"
                      onChangePage={(page) => setCurrentPage(page)}
                      onChangeRowsPerPage={(newPerPage) => {
                        setRowsPerPage(newPerPage);
                        setCurrentPage(1);
                      }}
                    />
                  )}
                  <RoleAssignmentModal
                    show={showModal}
                    handleClose={closeModal}
                    row={selectedRow}
                    handleRoleChange={handleRoleChange}
                    roleOptions={roleOptions}
                  />
                  <GroupModal
                    show={showGroupModal}
                    handleClose={closeGroupModal}
                    row={selectedRow}
                    handleGroupChange={handleGroupChange}
                    manadalId={id}
                  />
                  <AddGroupModal
                    show={showAddGroupModal}
                    handleClose={closeAddGroupModal}
                    handleGroupAdded={handleGroupAdded}
                    mandalId={id}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </MandalAdminLayout>
  );
}

export default HaribhaktTable;
